import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		main: {
			// ?safe&mock-data&utm_source=FB&country=US&area=main&exp=web_models_from_creos~1
			landing: {
				experiment: () =>
					import(/* webpackChunkName: "landing" */ '@/modules/Landing/instances/experiments/web_models_from_creos'),
			},
			funnel: {
				id: 'ob-models-from-creos',
				locale: ['en'],
			},
		},
	},
]

export default config
